import React, { useState } from "react";
import { Table,Divider } from "antd";
import { useHistory } from "react-router-dom";

const Content = (props) => {

  const { dataSource,page,onTableChange=()=>{},onShowSizeChange=()=>{},onEdit=()=>{} }=props;

  const history = useHistory();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleRedirect=(current,type)=>{
    if(type==='detail'){
      history.push(`/page/business/split/${current.companyId}`) 
    }else{
      history.push(`/page/business/split/record/${current.companyId}`) 
    } 
  }

  const columns=[
    {
      title: '运营商名称',
      dataIndex: 'companyName',
      key: 'companyName',
    },
    {
      title: '分账总额/元',
      dataIndex: 'shareAmount',
      key: 'shareAmount',
    }, 
    {
      title: '操作',
      dataIndex: 'name',
      key: 'name',
      render:(_,record)=>{
        return (
          <div>
            <a onClick={()=>handleRedirect(record,'detail')}>分账详情</a>
            <Divider type="vertical" />
            <a  onClick={()=>handleRedirect(record,'record')}>提现记录</a> 
          </div>
        )
      }
    },
  ]

  return (
    <div className="content">
      <Table
        rowSelection={false}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      /> 
    </div>
  );
};

export default Content;
